import { apiRequest } from "./api";

export const getMyCounters = (accessToken) =>
  apiRequest("/pos/counters/my", { accessToken });

export const getCounterStores = (accessToken) =>
  apiRequest("/pos/counters/stores", { accessToken });

export const getAllCounters = (accessToken) =>
  apiRequest("/pos/counters", { accessToken });

export const getCounter = (counterId, accessToken) =>
  apiRequest(`/pos/counters/${counterId}`, { accessToken });

export const createCounter = (body, accessToken) =>
  apiRequest("/pos/counters", {
    method: "POST",
    body,
    accessToken,
  });

export const updateCounter = (counterId, body, accessToken) =>
  apiRequest(`/pos/counters/${counterId}`, {
    method: "PATCH",
    body,
    accessToken,
  });

export const deleteCounter = (counterId, accessToken) =>
  apiRequest(`/pos/counters/${counterId}`, {
    method: "PATCH",
    body: { isActive: false },
    accessToken,
  });

export const reactivateCounter = (counterId, accessToken) =>
  apiRequest(`/pos/counters/${counterId}`, {
    method: "PATCH",
    body: { isActive: true },
    accessToken,
  });

export const getCounterUsers = (counterId, accessToken) =>
  apiRequest(`/pos/counters/${counterId}/users`, {
    accessToken,
  });

export const searchAssignableCounterUsers = (
  counterId,
  query,
  accessToken,
) =>
  apiRequest(
    `/pos/counters/${counterId}/assignable-users?search=${encodeURIComponent(query || "")}`,
    { accessToken },
  );

export const assignCounterUser = (counterId, body, accessToken) =>
  apiRequest(`/pos/counters/${counterId}/users`, {
    method: "POST",
    body,
    accessToken,
  });

export const updateCounterUser = (counterId, userId, body, accessToken) =>
  apiRequest(`/pos/counters/${counterId}/users/${userId}`, {
    method: "PATCH",
    body,
    accessToken,
  });

export const deactivateCounterUser = (counterId, userId, accessToken) =>
  apiRequest(`/pos/counters/${counterId}/users/${userId}/deactivate`, {
    method: "POST",
    accessToken,
  });

export const getCurrentSession = (accessToken) =>
  apiRequest("/pos/sessions/current", { accessToken });

export const openSession = (body, accessToken) =>
  apiRequest("/pos/sessions/open", {
    method: "POST",
    body,
    accessToken,
  });

export const closeSession = (sessionId, body, accessToken) =>
  apiRequest(`/pos/sessions/${sessionId}/close`, {
    method: "POST",
    body,
    accessToken,
  });

export const searchProducts = (query, accessToken) =>
  apiRequest(`/pos/catalog/products?query=${encodeURIComponent(query || "")}`, {
    accessToken,
  });

export const searchCustomers = (query, accessToken) =>
  apiRequest(`/pos/customers?query=${encodeURIComponent(query || "")}`, {
    accessToken,
  });

export const createCustomer = (body, accessToken) =>
  apiRequest("/pos/customers", {
    method: "POST",
    body,
    accessToken,
  });

export const createSale = (body, accessToken) =>
  apiRequest("/pos/sales", {
    method: "POST",
    body,
    accessToken,
  });

export const searchAgents = (query, accessToken) =>
  apiRequest(`/pos/agents?query=${encodeURIComponent(query || "")}`, {
    accessToken,
  });

export const validateCoupon = (body, accessToken) =>
  apiRequest("/pos/coupons/validate", {
    method: "POST",
    body,
    accessToken,
  });

export const createHeldBill = (body, accessToken) =>
  apiRequest("/pos/held-bills", {
    method: "POST",
    body,
    accessToken,
  });

export const getHeldBills = (accessToken) =>
  apiRequest("/pos/held-bills", { accessToken });

export const getHeldBill = (heldBillId, accessToken) =>
  apiRequest(`/pos/held-bills/${heldBillId}`, { accessToken });

export const cancelHeldBill = (heldBillId, accessToken) =>
  apiRequest(`/pos/held-bills/${heldBillId}/cancel`, {
    method: "POST",
    accessToken,
  });

export function getSaleForReturn(receiptNumber, accessToken) {
  return apiRequest(
    `/pos/returns/sales/${encodeURIComponent(receiptNumber.trim())}`,
    { accessToken },
  );
}

export function createPosReturn(payload, accessToken) {
  return apiRequest("/pos/returns", {
    method: "POST",
    body: payload,
    accessToken,
  });
}

export function getPosSalesHistory(query = "", accessToken) {
  const params = new URLSearchParams();

  if (query.trim()) {
    params.set("query", query.trim());
  }

  params.set("take", "50");

  return apiRequest(`/pos/sales/history?${params.toString()}`, {
    accessToken,
  });
}

export function getPosReceipt(receiptNumber, accessToken) {
  return apiRequest(
    `/pos/sales/receipt/${encodeURIComponent(receiptNumber.trim())}`,
    { accessToken },
  );
}

export function getPosCloseReport(sessionId, accessToken) {
  return apiRequest(`/pos/sessions/${sessionId}/close-report`, {
    accessToken,
  });
}

export function voidPosSale(saleId, payload, accessToken) {
  return apiRequest(`/pos/sales/${saleId}/void`, {
    method: "POST",
    body: payload,
    accessToken,
  });
}

export function getPosDailyReport(
  { date, branchId, storeId } = {},
  accessToken,
) {
  const params = new URLSearchParams();

  if (date) params.set("date", date);
  if (branchId) params.set("branchId", branchId);
  if (storeId) params.set("storeId", storeId);

  return apiRequest(`/pos/reports/daily?${params.toString()}`, {
    accessToken,
  });
}

export function getPosBills(filters = {}, accessToken) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  return apiRequest(`/pos/reports/bills?${params.toString()}`, { accessToken });
}

export function getPosBillReceipt(receiptNumber, accessToken) {
  return apiRequest(
    `/pos/reports/bills/${encodeURIComponent(receiptNumber.trim())}`,
    { accessToken },
  );
}

export async function searchEligibleReturnItems(
  query,
  customerId,
  accessToken,
) {
  const params = new URLSearchParams({ query });

  if (customerId) {
    params.set("customerId", customerId);
  }

  return apiRequest(`/pos/returns/eligible-items?${params.toString()}`, {
    accessToken,
  });
}

export async function createExchange(payload, accessToken) {
  return apiRequest("/pos/exchanges", {
    method: "POST",
    body: payload,
    accessToken,
  });
}
